export const SERVICE_TEL = 4001028028;
